<template>
  <FriedTableRow>
    <FriedTableCell colspan="8">
      <EmptyState :img-src="imgSrc" :message="message" />
    </FriedTableCell>
  </FriedTableRow>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import EmptyState from '@getaccept/lib-shared/src/components/EmptyState.vue';

export default defineComponent({
  name: 'EmptyStateRow',
  components: {
    EmptyState,
  },
  props: {
    imgSrc: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
});
</script>
